import React, { memo, useState } from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import { capitalize, cloneDeep, debounce } from 'lodash';
import { MenuItem } from 'material-ui';
import api from 'services';
import PropTypes from 'prop-types';

const PodPor = ({
    portType, port, changePortData, 
}) => {
    const [ports, setPorts] = useState([]);

    const dAutocomplete = debounce((searchText) => {
        if (searchText.length < 2) {
            return;
        }

        api.findPort({ name: searchText, withAreas: true })
            .then((response) => {
                const _ports = response.data.data.flatMap(_port => createPort(_port));
                setPorts(_ports);
            })
            .catch(() => null);
    }, 500);

    const createPort = (_port) => {
        const _ports = [];
        let name = '';

        if (_port.sub) {
            _port.sub.forEach((subPort) => {
                _ports.push({
                    item: subPort,
                    text: `${subPort.name} - country ${_port.country.name}`,
                    _id: _port._id,
                    value: (
                        <MenuItem
                            primaryText={`${subPort.name} - country ${_port.country.name}`}
                            value={subPort}
                            style={{ paddingLeft: '30px' }}
                        />
                    ),
                });
            });
        }

        name = _port.country ? `${_port.name} - country ${_port.country.name}` : _port.name;

        return [
            {
                _id: _port._id,
                text: name,
                item: _port,
                value: (
                    <MenuItem
                        primaryText={name}
                        value={_port}
                    />
                ),
            },
            ..._ports,
        ];
    };

    const changeAutoComplete = (searchText) => {
        const updatedPort = cloneDeep(port);
        updatedPort.name = searchText;
        if (!searchText) {
            delete updatedPort._id;
        }
        changePortData(portType, updatedPort);
        dAutocomplete(searchText);
    };

    const chooseAutoComplete = (selectedPort) => {
        if (!selectedPort) {
            return;
        }

        changePortData(portType, {
            ...port,
            port: selectedPort.item,
            _id: selectedPort.item._id,
        });
    };

    const label = capitalize(portType);

    return (
        <React.Fragment>
            <div className="row" style={{ display: 'flex' }}>
                <AutoComplete
                    floatingLabelText={label}
                    textFieldStyle={{ fontSize: '13px' }}
                    hintText={label}
                    searchText={port.name || ''}
                    dataSource={ports}
                    onUpdateInput={changeAutoComplete}
                    onNewRequest={chooseAutoComplete}
                    required
                    filter={AutoComplete.noFilter}
                    listStyle={{ overflow: 'auto', maxHeight: '300px', width: 'auto' }}
                    menuStyle={{ width: 'auto' }}
                    popoverProps={{
                        canAutoPosition: true,
                    }}
                    style={{ marginLeft: '10px' }}
                />
            </div>
        </React.Fragment>
    );
};

PodPor.propTypes = {
    portType: PropTypes.oneOf(['delivery', 'redelivery']).isRequired,
    port: PropTypes.object.isRequired,
    changePortData: PropTypes.func.isRequired,
};

export default memo(PodPor);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Hire/podPol/PodPol.jsx